((app, ng) => {

    app.controller("addFirelightAccountController", addFirelightAccountController);

    function addFirelightAccountController($mdDialog, carrierApi, carrierProductApi, householdRelationshipApi, firelightApi, _states) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.states = _states;
            $ctrl.clientHousehold = [$ctrl.client.Person];
            $ctrl.carriers = [];
            $ctrl.products = [];
            $ctrl.account = {
                CaseId: $ctrl.clientCase.Id,
                OwnerId: $ctrl.client.Person.Id,
            }
            $ctrl.ui = {};

            carrierApi.getCarriers().then(response => {
                $ctrl.carriers = response.filter(carrier => !!carrier.FirelightCarrierCode);
            });

            householdRelationshipApi.getHouseholdRelationships($ctrl.client.Id).then(response => {
                $ctrl.clientHousehold = [
                    ...$ctrl.clientHousehold,
                    ...response.map(relationship => relationship.TargetClient.Person)
                ];
            });
        };

        const close = (evt) => {
            $mdDialog.hide(evt);
        }

        const getCarrierProducts = (carrierId) => {
            const hasProducts = $ctrl.products.some(product => product.CarrierId === carrierId);

            if (!hasProducts) {
                carrierProductApi.getProductsPerCarrier(carrierId).then(response => {
                    const firelightProducts = response.filter(product => !!product.FirelightCusip);

                    $ctrl.products = [...$ctrl.products, ...firelightProducts];
                });
            }
        }

        const filterProducts = (product) => {
            if (product.StateList !== null) {
                if (product.StateList.length > 0) {
                    return product.StateList.indexOf($ctrl.account.State) > -1 && product.CarrierId === $ctrl.selectedCarrierId && product.IsActive;
                }
                return product.CarrierId === $ctrl.selectedCarrierId && product.IsActive;
            }
        }

        const launchFirelight = () => {
            $ctrl.ui.launching = true;

            const win = window.open();
            win.document.write("Loading...");

            firelightApi.initiateFirelightSso($ctrl.clientCase.Id, $ctrl.account).then(response => {
                win.document.write(response);

                win.document.forms.samlform.submit();

                $ctrl.ui.launching = false;

                $ctrl.ui.workingFirelight = true;
            },
                () => {
                    win.document.write("Failed. There was an error accessing this resource.");
                });
        }

        function createInsuranceAccount() {
            $ctrl.ui.launching = true;
            var product = _.find($ctrl.carrierProducts,
                function (row) { return row.Id === $ctrl.account.InsuranceAccount.CarrierProductId });
            $ctrl.account.InsuranceAccount.Title = product.Carrier.Business.Name + " " + product.Name;
            $ctrl.account.InsuranceAccount.CaseId = $ctrl.clientCase.Id;
            var jointOwnerId = null;
            var annuitantId = null;
            var jointAnnuitantId = null;
            var primaryBeneficiaryIds = [];
            var contigentBeneficiaryIds = [];
            if ($ctrl.account.InsuranceAccount.jointOwner) {
                jointOwnerId = $ctrl.account.InsuranceAccount.jointOwner.Person.Id;
            }

            if ($ctrl.account.InsuranceAccount.jointAnnuitant) {
                annuitantId = $ctrl.account.InsuranceAccount.jointAnnuitant.Person.Id;
            }
            if ($ctrl.account.InsuranceAccount.annuitant) {
                jointAnnuitantId = $ctrl.account.InsuranceAccount.annuitant.Person.Id;
            }
            ng.forEach($ctrl.account.InsuranceAccount.PrimaryBeneficiary,
                function (bene) {
                    primaryBeneficiaryIds.push(bene.Person.Id);
                });
            ng.forEach($ctrl.account.InsuranceAccount.ContigentBeneficiary,
                function (bene) {
                    contigentBeneficiaryIds.push(bene.Person.Id);
                });
            var accountModel = {
                CaseId: $ctrl.clientCase.Id,
                ProductId: $ctrl.account.InsuranceAccount.CarrierProductId,
                JointOwnerId: jointOwnerId,
                AnnuitantId: annuitantId,
                JointAnnuitantId: jointAnnuitantId,
                PrimaryBeneficiaryIds: primaryBeneficiaryIds,
                ContigentBeneficiaryIds: contigentBeneficiaryIds,
                State: $ctrl.account.InsuranceAccount.State,
                InsuranceAccountId: null
            }
            var w = window.open();
            w.document.write("Loading...");
            return firelightApi.initiateFirelightSso($ctrl.account.InsuranceAccount.CaseId, accountModel).then(function (ssoInfo) {
                $ctrl.ui.launching = false;
                $ctrl.ui.workingFirelight = true;
                w.document.write(ssoInfo);
                w.document.forms.samlform.submit();
            }, function (error) {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }

        ng.extend($ctrl,
            {
                close,
                getCarrierProducts,
                launchFirelight,
                filterProducts
            });
    }

})(window.app, window.angular); //jshint: ignore:line